<template>
  <div>
    <page-header
      :page="page"
      left-side-class="col-xl-8"
      :actions="headerActions"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />
    <add-equipment
      v-if="addEquipment"
      class="mb-4"
      @cancel="onCancelAddEquipment"
      @save="onSaveAddEquipment"
    ></add-equipment>

    <filter-manager
      ref="filter"
      v-model="filter.model"
      :filters="filtersHeader"
      class="filter-manager_extended"
      search-container-class="col-lg-1 search-btn"
      :display-advanced="false"
      search-text=""
      @classification="getFilterOptions"
    >
      <div class="col-12 col-lg-1 d-flex align-items-end">
        <action-button
          class="search mb-2 col-12"
          i="fas fa-search"
          text="Buscar"
          variant="success"
          @click="onSearchHandler"
        />
      </div>
    </filter-manager>
    <custom-separator
      class="my-4 custom-separator"
      text="Resultados de Equipos"
    />

    <custom-result-not-found
      v-if="showNotResults"
      class="mt-4 row pt-3"
      text="No hay Información Disponible."
    />
    <div v-else>
      <inventory-result-row
        v-for="(item, index) in results"
        :key="index"
        :item="item"
      />
      <pagination
        v-if="pagination.totalItemCount > pagination.pageSize"
        :data="pagination"
        :page-size="pagination.pageSize"
        @pagination-go-page="onPageChange"
      />
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import ActionButton from 'ActionButton';
import FilterManager from '@/components/common/CustomFilterManager.vue';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import referralService from '@/services/api/referralsandequipments.api';
import inventoryCatalogService from '@/services/api/inventorycatalog.api';
import AddEquipment from './components/AddEquipment.vue';
import Pagination from 'pagination';
import InventoryResultRow from './components/InventoryResultRow.vue';
import storeMixin from '@quisit/mipe-utils/mixins/storeGenerator';
const MODULE_NAME = 'InventoryManagement';
const DEFAULT_PAGE_SIZE = 10;

export default {
  components: {
    PageHeader,
    FilterManager,
    ActionButton,
    CustomSeparator,
    CustomResultNotFound,
    Pagination,
    AddEquipment,
    InventoryResultRow,
  },
  mixins: [storeMixin],
  data() {
    return {
      moduleName: MODULE_NAME,
      addEquipment: false,
      page: {
        icon: 'fas fa-laptop',
        title:
          'Mantenimiento del Catálogo de Equipos de Asistencia Tecnológica',
        routes: [
          'Asistencia Tecnológica',
          'Inventario',
          'Mantenimiento del Catálogo de Equipos de Asistencia Tecnológica',
        ],
      },
      filter: {
        model: {
          inventory: null,
          classification: null,
        },
        options: {
          inventoryCatalog: [],
          classifications: [],
        },
      },
      results: [],
      pagination: {
        count: 0,
        currentPage: 1,
        pageCount: 1,
        totalItemCount: 0,
        pageSize: 10,
      },
    };
  },
  computed: {
    headerActions() {
      return [
        {
          text: 'Añadir Equipo',
          icon: 'fas fa-file-plus',
          variant: 'success',
          click: () => (this.addEquipment = true),
        },
      ];
    },
    filtersHeader() {
      return [
        {
          name: 'classification',
          component: 'CustomDropDown',
          value: this.filter.model.classification,
          options: this.filter.options.classifications,
          placeholder: 'Catálogo de Cumplimiento',
          class: 'col-12 col-lg-6',
          fieldName: 'name',
          fieldKey: 'id',
        },
        {
          name: 'inventory',
          component: 'CustomDropDown',
          value: this.filter.model.inventory,
          options: this.filter.options.inventoryCatalog,
          placeholder: 'Nombre de Equipo',
          class: 'col-12 col-lg-5',
          fieldName: 'name',
          fieldKey: 'id',
        },
      ];
    },
    showNotResults() {
      return this.results.length == 0;
    },
  },
  async mounted() {
    await Promise.allSettled([this.getEquipmentClassifications()]);
  },
  destroyed() {
    this.persistData();
  },
  methods: {
    async onSearchHandler(page = 1) {
      const { inventory, classification } = this.filter.model;

      const { data } = await inventoryCatalogService.search({
        inventoryId: inventory?.id,
        classificationId: classification?.id,
        currentPage: page,
        pageSize: this.pagination.pageSize,
      });

      this.results = data.data.map((x) => ({ ...x, isOpen: false }));

      this.pagination = {
        pageSize: DEFAULT_PAGE_SIZE,
        totalItemCount: data.totalItemCount,
        pageCount: data.pageCount,
        currentPage: data.currentPage,
        count: data.count,
      };
    },
    async onPageChange(page) {
      this.onSearchHandler(page);
    },
    async getEquipmentClassifications() {
      const { data } = await referralService.getEquipmentClassifications();
      this.filter.options.classifications = data;
    },
    async getFilterOptions(classification) {
      this.filter.options.inventoryCatalog = [];
      this.filter.model.inventory = null;

      if (!classification) {
        return;
      }

      const { data } = await inventoryCatalogService.getFilterOptions(
        classification.id
      );
      this.filter.options.inventoryCatalog = data;
    },
    onCancelAddEquipment() {
      this.addEquipment = false;
    },
    onSaveAddEquipment() {
      this.addEquipment = false;
      this.onSearchHandler(1);
    },
  },
  beforeRouteEnter(_, from, next) {
    const routes = ['inventoryManagement'];
    next(async (vm) => {
      if (routes.includes(from.name)) {
        vm.recoveryData();
        await vm.onPageChange(1, false);
      } else {
        vm.shouldRecovery = false;
      }
    });
  },
};
</script>

<style></style>
